







































import { WithErrorModal } from '@/components/organisms/dialog/error-dialog/with-error-modal'
import ErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import HeaderBottomUserNotification from '@ajax/vue/components/templates/HeaderBottomUserNotification.vue'
import TitleSection from '@spa/components/atoms/TitleSection.vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ErrorDialog,
    HeaderBottomUserNotification,
    TitleSection,
  },
})
export default class LoginPageWithTitleSection extends Mixins<WithErrorModal>(WithErrorModal) {
  @Prop({ default: '/s/mypage' })
  /**
   * @see LoginPageProps.next
   */
  readonly next: string

  @Prop({ default: '/signup' })
  /**
   * @see LoginPageProps.signupLink
   */
  readonly signupLink: string

  @Prop({ default: 'ログイン' })
  /**
   * @see LoginPageProps.title
   */
  readonly title: string

  @Prop({ default: () => BehaviorConfig.forHost })
  readonly behavior: Pick<BehaviorConfig, 'groupLabel'>

  get serviceName(): string {
    return this.behavior.groupLabel
  }
}
